/**
 * **Les clés de cache, CENTRALISÉES PAR FEATURE, en fabrique.**
 *
 * `DOCTRINE.md` §6 : « les clés de cache sont centralisées par feature dans une fabrique,
 * au format tableau préfixé par le nom de la feature. **Une clé improvisée casse
 * l'invalidation en silence.** »
 *
 * Elles vivent ici plutôt que dans chaque feature parce que **l'invalidation traverse les
 * features** : envoyer un message invalide le fil ET l'annuaire, terminer un cours
 * invalide l'arrivée ET l'historique. Une fabrique par feature obligerait chacune à
 * importer l'intérieur des autres, ce que la doctrine interdit.
 */
export const CLES = {
  session: ['session'] as const,

  arrivee: ['arrivee'] as const,

  historique: {
    tout: ['historique'] as const,
    liste: (recherche: string | undefined) =>
      ['historique', 'liste', recherche ?? ''] as const,
    totaux: ['historique', 'totaux'] as const,
  },

  annuaire: ['annuaire'] as const,

  conversations: {
    tout: ['conversations'] as const,
    liste: ['conversations', 'liste'] as const,
    fil: (conversationId: string) =>
      ['conversations', 'fil', conversationId] as const,
  },

  espace: ['espace'] as const,

  reglages: {
    tout: ['reglages'] as const,
    ecran: ['reglages', 'ecran'] as const,
    rattachements: ['reglages', 'rattachements'] as const,
    adressesPassees: ['reglages', 'adresses-passees'] as const,
    connexions: ['reglages', 'connexions'] as const,
  },

  cours: {
    tout: ['cours'] as const,
    tableau: (coursId: string, rang: number) =>
      ['cours', coursId, 'tableau', rang] as const,
    /**
     * **L'état du tableau vivant d'un cours** — la lecture de D-110, seconde correction.
     *
     * **Sans rang, et c'est le point** : celle d'à côté s'adresse par rang, celle-ci
     * demande « lequel est le vivant, et où en est sa jauge ». Les deux ne s'invalident
     * pas ensemble — la scène ne bouge pas quand le poids change.
     */
    tableauCourant: (coursId: string) =>
      ['cours', coursId, 'tableau-courant'] as const,
    /**
     * **Le droit d'entrée dans le canal de visio** — F-31.
     *
     * **Il est sous `cours` et non sous une clé à lui**, parce qu'il ne survit pas au
     * cours : terminer un cours invalide `cours.tout`, donc le droit part avec. Une
     * clé séparée le laisserait en cache après la fin, et le prochain rendu
     * repartirait sur un jeton que le serveur ne reconnaît plus.
     */
    canal: (coursId: string) => ['cours', coursId, 'canal'] as const,
  },

  presence: ['presence'] as const,
} as const;
